<div class="loading-overlay">
 <div class="loader"></div>
 <br>
 <p>{{message}}</p>
</div>

